export default __webpack_public_path__ + "static/media/guide_01_01.a6e5abbb.png";